import React from "react"
import { TAKE_ME_BACK, CANCEL, CONTINUE_TEXT } from "../../constants/messages"
import { CustomModal, Button, TextTag } from "../../atoms"

//Modal called when paying for tab scenarios for disclaimers and preventing back modal popups
const BlockingModal = (props) => {
  const { withOptions = false, buttonText, disabled = false } = props
  return withOptions ? (
    <CustomModal
      title={props.title}
      keyboard={false}
      visible={props.blockingModalVisibility}
      maskClosable={false}
      closable={false}
      footer={[
        <Button
          key="continue"
          disabled={disabled}
          onClick={() => props.continueHandler()}
        >
          {buttonText || TAKE_ME_BACK}
        </Button>,
        <Button
          key="cancel"
          btnType="bordered"
          onClick={() => props.cancelHandler()}
        >
          {CANCEL}
        </Button>,
      ]}
    >
      <TextTag>{props.content}</TextTag>
    </CustomModal>
  ) : (
    <CustomModal
      title={props.title}
      visible={props.blockingModalVisibility}
      keyboard={false}
      maskClosable={false}
      closable={false}
      footer={[
        <Button key="continue" onClick={() => props.continueHandler()}>
          {buttonText || CONTINUE_TEXT}
        </Button>,
      ]}
    >
      {props.content}
    </CustomModal>
  )
}

export default BlockingModal
